import React from 'react'
import Offers from '../../content/Offers'

const Grid = (props) => {
  return <Offers {...props} title="Grid" />
}

export default Grid
